'use client';

import MyProfileImg from '@/components/my/common/item/MyProfileImg';
import globalDomains from '@/utils/global-domains';

import useProfileClickLog from '@/components/my/common/hooks/useProfileClickLog';

/**
 * MyAvatar 컴포넌트
 * @param {Object} props - MyAvatar props
 * @param {string} props.userNick - 사용자 닉네임
 * @param {boolean} props.isFanclub - 팬클럽 여부
 * @param {boolean} props.isSubscribe - 구독 여부
 * @param {ReactNode} props.hoverComponent - hover 시 나타나는 컴포넌트
 * @param {string} props.userId - 사용자 ID
 * @param {function} props.handleUserPin - 사용자 핀 클릭 핸들러
 * @param {number} props.favoriteNo - 즐겨찾기 번호
 * @param {boolean} props.isPin - 핀 여부
 * @param {boolean} [props.isShowSubscribe=true] - 구독 여부 표시할지 여부
 * @param {boolean} [props.isShowFanclub=true] - 팬클럽 여부 표시할지 여부
 * @param {Object[]} props.broadInfo - 방송 정보
 * @param {boolean} props.isLive - 라이브 여부
 * @returns {JSX.Element} MyAvatar 컴포넌트
 */
const MyAvatar = ({
  userNick,
  isFanclub,
  isSubscribe,
  hoverComponent,
  userId,
  handleUserPin,
  favoriteNo,
  subscribeNo,
  isPin,
  fanclubNo,
  isShowSubscribe = true,
  isShowFanclub = true,
  broadInfo,
  isLive,
}) => {
  // 핀 클릭 시 처리
  const handlePinClick = (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (!handleUserPin) return;

    // 핀 클릭 시 즐겨찾기, 구독 번호를 넘김
    handleUserPin(favoriteNo || subscribeNo || fanclubNo, isPin);
  };

  // 방송 정보가 있으면 방송 URL, 없으면 기본 URL 설정
  const profileLink =
    broadInfo?.length > 0
      ? broadInfo[0].url
      : `${globalDomains.BJ_AFREECATV}/${userId}`;

  // 프로필 클릭 시 로그 전송
  const {sendProfileClickLog} = useProfileClickLog(isLive, broadInfo);

  return (
    <a href={profileLink} target='_blank' onClick={sendProfileClickLog}>
      {/* 프로필 이미지 */}
      <div className='thumb'>
        <MyProfileImg userId={userId} shouldLoadImage />
        <span className='community'>{hoverComponent}</span>
      </div>

      {/* 사용자 닉네임 */}
      <div className='nick'>
        <span>{userNick}</span>

        {/* 팬클럽 여부 표시 */}
        {isShowFanclub && isFanclub && (
          <span className='grade-badge-fan' tip='팬클럽'>
            F
          </span>
        )}

        {/* 구독 여부 표시 */}
        {isShowSubscribe && isSubscribe && (
          <span className='grade-badge-subscribe' tip='구독'>
            구독
          </span>
        )}
      </div>

      {/* 유저 핀 */}
      <button
        type='button'
        className='pin'
        onClick={handlePinClick}
        tip={isPin ? '고정 해제하기' : '고정하기'}>
        고정
      </button>
    </a>
  );
};

export default MyAvatar;
